import { css } from '@emotion/react';
import { styled } from '@sds-system/system';
import type { AllStyledProps } from '@sds-system/types';
import { getAllStyledProps, mediaQuery } from '@sds-system/utils';
import { Column } from '../Column';

export const StyledErrorPageRoot = styled(Column)<AllStyledProps>(({ theme }) => {
  return css`
    width: 100%;
    padding: 0 45px;
    padding-top: 120px;
    display: flex;
    align-items: center;

    & > .error-page-img {
      ${mediaQuery(
        {
          width: ['120px', '200px'],
          height: ['120px', '200px'],
        },
        theme,
      )}
    }
  `;
}, getAllStyledProps);
